import { X, Plus } from "lucide-react"

import { Button } from "../../../../components/ui/button"
import { Input } from "../../../../components/ui/input"
import { DataTableViewOptions } from "../../../../components/ui/data-table-view-options"
import { Combobox } from "../../../../components/ui/combobox"
import { Role } from "types/settings"

interface ComboboxOption {
  value: string
  label: string
}

interface UsersToolbarProps {
  table: any;
  roles: Role[];
  selectedUserType?: string;
  selectedRoleId?: number;
  search: string;
  onSearchChange: (value: string) => void;
  onUserTypeChange: (value?: string) => void;
  onRoleChange: (value?: number) => void;
  onCreateUser?: () => void;
}

export function UsersToolbar({ 
  table, 
  roles,
  selectedUserType,
  selectedRoleId,
  search,
  onSearchChange,
  onUserTypeChange,
  onRoleChange,
  onCreateUser
}: UsersToolbarProps) {

  const userTypeOptions: ComboboxOption[] = [
    { value: "", label: "All User Types" },
    { value: "Internal", label: "Internal" },
    { value: "Customer", label: "Customer" },
    { value: "Demo", label: "Demo" },
  ];

  const roleOptions: ComboboxOption[] = [
    { value: "", label: "All Roles" },
    ...roles.map(role => ({
      value: String(role.role_id),
      label: role.role_desc,
    })),
  ];

  const handleUserTypeChange = (value: string) => {
    onUserTypeChange(value === "" ? undefined : value);
  };

  const handleRoleChange = (value: string) => {
    onRoleChange(value === "" ? undefined : Number(value));
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter users..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-8 w-[150px] lg:w-[250px]"
        />

        <div className="h-8 w-[180px]">
          <Combobox
            options={userTypeOptions}
            value={selectedUserType ?? ""}
            onValueChange={handleUserTypeChange}
            placeholder="User Type"
            searchPlaceholder="Search user type..."
            emptyText="No user type found."
            buttonClassName="h-8 text-xs font-normal text-gray-600"
          />
        </div>

        <div className="h-8 w-[200px]">
          <Combobox
            options={roleOptions}
            value={selectedRoleId ? String(selectedRoleId) : ""}
            onValueChange={handleRoleChange}
            placeholder="Role"
            searchPlaceholder="Search role..."
            emptyText="No role found."
            buttonClassName="h-8 text-xs font-normal text-gray-600"
          />
        </div>

        {(selectedUserType || selectedRoleId || search) && (
          <Button
            variant="ghost"
            onClick={() => {
              onUserTypeChange(undefined);
              onRoleChange(undefined);
              onSearchChange("");
            }}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <X className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="flex items-center space-x-2">
        {onCreateUser && (
          <Button onClick={onCreateUser} className="h-8">
            <Plus className="mr-2 h-4 w-4" />
            Create User
          </Button>
        )}
        <DataTableViewOptions table={table} />
      </div>
    </div>
  )
}
